import React from 'react'
import styled from 'react-emotion'
import { z } from '../../../style';

const size = 8

export const ResizeHandle = styled(({ direction, className }) => (
  <div className={className} data-action={'resize-' + direction} />
))(({ direction }) => {
  const style = {
    label: 'ResizeHandle',
    position: 'absolute',
    width: size,
    height: size,
    outline: '1px solid rgba(32, 32, 32, 0.2)',
    background: '#fff',
    zIndex: z.resizeHandle
  }
  switch (direction) {
    case 'n':
      style.left = `calc(50% - ${size/2}px)`
      style.top = size * -0.5
      style.cursor = 'ns-resize'
      break
    case 's':
      style.left = `calc(50% - ${size/2}px)`
      style.bottom = size * -0.5
      style.cursor = 'ns-resize'
      break
    case 'e':
      style.right = size * -0.5
      style.top = `calc(50% - ${size/2}px)`
      style.cursor = 'ew-resize'
      break
    case 'w':
      style.left = size * -0.5
      style.top = `calc(50% - ${size/2}px)`
      style.cursor = 'ew-resize'
      break
    case 'ne':
      style.right = size * -0.5
      style.top = size * -0.5
      style.cursor = 'nesw-resize'
      break
    case 'nw':
      style.left = size * -0.5
      style.top = size * -0.5
      style.cursor = 'nwse-resize'
      break
    case 'se':
      style.right = size * -0.5
      style.bottom = size * -0.5
      style.cursor = 'nwse-resize'
      break
    case 'sw':
      style.left = size * -0.5
      style.bottom = size * -0.5
      style.cursor = 'nesw-resize'
      break
    default:
      break
  }
  return style
})

export default ResizeHandle